module.exports = __webpack_public_path__ + "img/crc-06.aab5ae0b.jpg";